import React, { useEffect, useState } from 'react';
import { Toolbar, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useGetList, useDataProvider, useNotify, useRefresh } from 'react-admin';
import { useLocation } from 'react-router-dom';

export const BrandSelectorToolbar = () => {
  const [brand, setBrand] = useState(() => sessionStorage.getItem('current-brand') || 'all');
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh(); 
  const location = useLocation();

  const { data: brands, isLoading, error } = useGetList(
    'brand',
    { pagination: { page: 1, perPage: 100 }, sort: { field: 'name', order: 'ASC' } }
  );
  
  useEffect(() => {
    const storedBrand = sessionStorage.getItem('current-brand');
    
    if (storedBrand && brands?.some(brand => brand.id === storedBrand)) {
        setBrand(storedBrand);
    }
    else if (brands && brands.length === 1) {
      updateBrand(brands[0].id);
    }
    else if (!storedBrand) {
        setBrand('all');
    }
}, [brands]);

  const handleChange = (event) => {
    const newId = event.target.value;
    updateBrand(newId);
    /*
    setBrand(newId);
     
    if (newId === 'all') {
      sessionStorage.removeItem('current-brand');
    } else {
      sessionStorage.setItem('current-brand', newId);
    }
    
    refresh();
    */
  };

  const updateBrand = (brandId:string) => {
    setBrand(brandId);
    if (brandId === 'all') {
      sessionStorage.removeItem('current-brand');
    } else {
      sessionStorage.setItem('current-brand', brandId);
    }
    refresh();
  }

  if (isLoading) return <div>Loading...</div>;
  if (!brands) return null;
  
  
  // JK TODO - Other code is triggered by the state storage here, but generally removing the brand selector from all views including MMAdmin
  /** Code that follows this will not run, removing the brand selector from all views including MMAdmin */
  if (brands.length === 1) {
    return (<div>{brands[0].name}</div>)
  }
  else {
    return (<div/>)
  }
  

  const hasSelectedTenant = sessionStorage.getItem('current-tenant') ? true : false;
  const allBrandsOption = { brandId: 'all', name: 'All Brands' };
  const brandsWithAllOption = [allBrandsOption, ...brands];
  //const isDisabled = location.pathname.includes('/tenant');

  return (
    <div style={{ padding: 0 }}>
      <FormControl variant="filled" fullWidth style={{ margin: 0 }}>
        <InputLabel id="brand-select-label" style={{ color: 'white' }}>Brand</InputLabel>
        <Select
          labelId="brand-select-label"
          id="brand-select"
          value={brand}
          onChange={handleChange}
          label="Brand"
          disabled={!hasSelectedTenant}
          style={{ color: 'white', width: '300px' }}
        >
          {brandsWithAllOption.map((brand) => (
            <MenuItem key={brand.brandId} value={brand.brandId}>
              {brand.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default BrandSelectorToolbar;